<script lang="ts">
  // The account's permanent home for the email connect form — see
  // EmailAccountConnect.svelte for the actual fields/guides/test/sync
  // (also mounted from EmailsPage as the "not connected" onboarding door).
  import EmailAccountConnect from '$lib/components/EmailAccountConnect.svelte';
</script>

<EmailAccountConnect />
